import {
  isPage,
  applyThemeClass,
  cleanContent,
  moveWidgetsToMainContent,
} from '../utils/helpers.js';
import { initWidgets } from './initWidgets.js';

export function fiberTheme() {
  const themeClassName = 'fiber-fest';
  const themeHomepageClassName = 'fiber-fest-home';

  if (isPage(themeClassName)) {
    applyThemeClass(themeClassName);
    initWidgets();

    $('link[href*="favicon"]').each(function () {
      $(this).attr('href', `${CLIENTRESOURCEPATH}dist/images/fiber/favicon.ico?sv=${SITEVERSION}`);
    });

    setTimeout(() => {
      $(`.${themeClassName}`).addClass('loaded');
    }, 1000);
  }

  if (isPage(themeHomepageClassName)) {
    $(globalThis).on('load', function () {
      $('#goog-gt-tt').remove();
    });
    cleanContent();
    moveWidgetsToMainContent(themeData);
  }
}
